import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { AngularFirestore, AngularFirestoreCollection } from "@angular/fire/compat/firestore";
import { EventBusService, UserService, WindowService, environment } from "@mypxplat/xplat/core";

import { ChannelBaseComponent } from "@mypxplat/xplat/features";
import { AppService, WebCommunityService } from "@mypxplat/xplat/web/core";
import { CreatePostInputComponent, SphereSubscribeStripeComponent } from "@mypxplat/xplat/web/features";
import { map, takeUntil } from "rxjs/operators";

@Component({
  selector: "myp-channel",
  templateUrl: "channel.component.html",
})
export class ChannelComponent extends ChannelBaseComponent {
  private _selectedChannel: any;
  @Input() set selectedChannel(channel) {
    this._selectedChannel = channel;
    if (channel) {
      this.initPosts();
    }
  }

  get selectedChannel() {
    return this._selectedChannel;
  }

  private _selectedTopic: any;
  @Input() set selectedTopic(topic) {
    this._selectedTopic = topic;
    if (topic) {
      this.initPosts();
    }
  }

  get selectedTopic() {
    return this._selectedTopic;
  }

  @Input() postType = "channels";
  public queuedPosts: Array<any>;
  @ViewChild("pagingContainer", { static: false }) pagingContainer: ElementRef;
  @ViewChild("createPostInput") createPostInput: CreatePostInputComponent;
  @Output() channelSelected: EventEmitter<any> = new EventEmitter();
  @Output() topicSelected: EventEmitter<any> = new EventEmitter();
  @Output() postsLoaded: EventEmitter<any> = new EventEmitter();
  public loading: boolean = true;
  public shouldShowPagination: boolean;

  constructor(
    userService: UserService,
    public communityService: WebCommunityService,
    public db: AngularFirestore,
    public appService: AppService,
    private _win: WindowService,
    public eventBusService: EventBusService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.communityService.getAvailableSkills();
  }

  showMore() {
    this.communityService.getPostsWithReplies({ channel: this.selectedChannel }).then((result: any) => {});
  }

  queuedPostsUpdate(args) {
    this.queuedPosts = args;
  }

  initPosts() {
    this.loading = true;
    this.communityService
      .getPostsWithReplies({
        channel: this.postType == "channels" ? this.selectedChannel : false,
        topic: this.postType == "topics" ? this.selectedTopic : false,
        limit: this.user.active_subscription ? 30 : 15,
        clear: true,
      })
      .then((result: any) => {
        this.loading = false;
        this.postsLoaded.next(true);
        this.communityService.watchPostsWithReplies(this.selectedChannel, this.selectedTopic);
      });

    if (
      this.selectedChannel &&
      this.communityService.channelSplashes[this.selectedChannel.string_id] &&
      this.communityService.channelSplashes[this.selectedChannel.string_id].indexOf('id="youtubelink"') > -1
    ) {
      this._win.setTimeout(() => {
        let link = document.getElementById("youtubelink");
        if (link) {
          let youtubeID = link.getAttribute("data-youtube-id");
          link.addEventListener("click", () => {
            this.showVideo(youtubeID);
          });
        }
      }, 100);
    }
    if (this.selectedTopic && this.selectedTopic.description && this.selectedTopic.description.indexOf('id="youtubelink"') > -1) {
      this._win.setTimeout(() => {
        let link = document.getElementById("youtubelink");
        if (link) {
          let youtubeID = link.getAttribute("data-youtube-id");
          link.addEventListener("click", () => {
            this.showVideo(youtubeID);
          });
        }
      }, 100);
    }
  }

  showVideo(id, type = "youtube") {
    this.eventBusService.emit(this.eventBusService.types.playVideo, {
      id: id,
      type: type,
    });
  }

  upgrade() {
    const modalRef = this.appService.showModal(SphereSubscribeStripeComponent, {
      size: "xl",
      backdrop: "static",
    });
    modalRef.componentInstance.isModal = true;
  }

  ngOnDestroy() {
    this.communityService.unwatch();
  }
}
